import { IconButton } from "@mui/material"
import { Add } from "@mui/icons-material"
import React from "react"

export const TableAddIcon = ({onClick}: {onClick: () => void}) => {
    return <IconButton color='primary' size="small" onClick={onClick}><Add /></IconButton>
}